import { ReactElement } from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { IndicatorType, ISchemaNode } from "../../../types";
import mainModule from "../../mainModule";

interface IChildComponentProps {
  node: ISchemaNode;
}

const ChildComponent = ({ node }: IChildComponentProps): ReactElement => {

  return (
    <Card sx={{
      margin: "1em",
      minWidth: 300,
      maxWidth: 400,
    }}>
      <CardContent style={{  padding: 0 }}>
        <div className="p-1" style={{ background: node.color ?? "transparent" }}>
          <Typography variant="h5" className="text-center m-0">
            {node.name}
          </Typography>
        </div>

        <div className="p-1">
          { node.indicator.filter(x => x.type === IndicatorType.DASHBOARD).map((indicator, index) => {
            const component = mainModule.getIndicator(indicator);

            return <div key={`general-dashboard-${node.nodeID}-${index}`}>{component}</div>;
          })
          }
        </div>
      </CardContent>
    </Card>
  );
};

export default ChildComponent;
